document.addEventListener('DOMContentLoaded',function(){
  var form=document.querySelector('[data-band-config] form');
  if(!form)return;
  var steps=Array.from(form.querySelectorAll('.step'));
  var media=window.matchMedia('(max-width:760px)');

  function openStep(step){
    steps.forEach(function(other){
      other.classList.remove('mobile-step-open');
      var otherHeading=other.querySelector(':scope>h2');
      if(otherHeading)otherHeading.setAttribute('aria-expanded','false');
    });
    if(step){
      step.classList.add('mobile-step-open');
      var heading=step.querySelector(':scope>h2');
      if(heading)heading.setAttribute('aria-expanded','true');
    }
  }

  function stepIsValid(step){
    var fields=Array.from(step.querySelectorAll('input,select,textarea'));
    for(var i=0;i<fields.length;i++){
      if(!fields[i].checkValidity()){
        fields[i].reportValidity();
        return false;
      }
    }
    return true;
  }

  steps.forEach(function(step,index){
    var heading=step.querySelector(':scope>h2');
    if(!heading)return;
    heading.setAttribute('role','button');
    heading.setAttribute('tabindex','0');
    function toggle(){
      if(!media.matches)return;
      var open=!step.classList.contains('mobile-step-open');
      openStep(open?step:null);
    }
    heading.addEventListener('click',toggle);
    heading.addEventListener('keydown',function(event){if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle()}});
    if(index===0)step.classList.add('mobile-step-open');

    var nextButton=document.createElement('button');
    nextButton.type='button';
    nextButton.className='mobile-step-next';
    nextButton.textContent=index===steps.length-1?'Auswahl übernehmen':'Übernehmen & weiter';
    nextButton.addEventListener('click',function(){
      if(!media.matches||!stepIsValid(step))return;
      step.classList.add('mobile-step-done');
      var next=steps[index+1];
      openStep(next||null);
      var target=next||form.querySelector('[data-order-summary]')||form.querySelector('.purchase');
      if(target)setTimeout(function(){target.scrollIntoView({behavior:'smooth',block:'start'})},60);
    });
    step.appendChild(nextButton);
  });

  function sync(){
    form.classList.toggle('mobile-steps-enabled',media.matches);
    steps.forEach(function(step,index){var heading=step.querySelector(':scope>h2');if(!heading)return;if(media.matches){if(!steps.some(function(x){return x.classList.contains('mobile-step-open')}))steps[0].classList.add('mobile-step-open');heading.setAttribute('aria-expanded',step.classList.contains('mobile-step-open')?'true':'false')}else{heading.removeAttribute('aria-expanded')}});
  }
  media.addEventListener?media.addEventListener('change',sync):media.addListener(sync);
  sync();
});
